import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { useRoute, useRouter } from '@/router'
import { UserModule } from '@/store/modules/user'
import { SimpleUploaderModule } from '@/store/modules/simple-uploader'
import { MessageBox } from 'element-ui'
import { redirectToLogin } from '@/utils'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  title: {
    type: String,
    required: true,
  },
  logo: {
    default: require('@/assets/logo.png')
  },
  companyName: {
    type: String,
    required: true,
  }
},
  setup(__props) {

const showLogo = false
const logoSrc = require('@/assets/logo-北师大.svg')
const smallLogoSrc = require('@/assets/logotype-北师大.svg')


const route = useRoute()
const router = useRouter()
const routes = computed(() => {
  const currentRoute = router.currentRoute
  return router.options.routes?.filter(i => {
    return !i.meta?.hidden && currentRoute.meta?.navSortIndex === i.meta?.navSortIndex
  })
})
const activeMenuName = computed(() => {
  const { meta } = route.value
  if (meta?.title) {
    return meta.title
  }
  return ''
})

const username = computed(() => UserModule.userInfo.username)

function logout () {
  // 退出前先判断是否有文件正在上传（由于目前是通过打开url方式来进行退出，这里暂时不会触发）
  const needSimpleUploaderAlert = SimpleUploaderModule.isFileUploading
  if(needSimpleUploaderAlert) {
    MessageBox.confirm('上传任务进行中，关闭会导致任务中断，请确认')
      .then(() => {
        UserModule.LogOut()
        redirectToLogin()
      })
      .catch(() => {})
  } else {
    UserModule.LogOut()
    redirectToLogin()
  }
}
// // 切换一级菜单、路由跳转
// const handleSelect = (index: string) => {
//   console.log('index: ', index);
//   // router.push(index)
//   (document.activeElement as any)?.blur()
// }

// const activeMenu = computed(() => {
//   const { meta, path } = route.value
//   if (meta?.activeMenu) {
//     return meta.activeMenu
//   }
//   return path
// })
function handleBackHome() {
  router.push('/')
}
// const options = [
//   {
//     label: '账户信息',
//     command: 'account'
//   },
//   {
//     label: '使用帮助',
//     command: 'manual'
//   }
// ]
// function handleCommand(command: string) {
//   if (command === 'account') {
//     const currentRoute = router.currentRoute
//     if (currentRoute.name !== 'account') {
//       router.push('/account')
//     }
//   } else if (command === 'manual') {
//     // TODO 后续替换用户手册文件
//     let fileName = '使用手册.pdf'
//     window.open(`/static/pdf/${fileName}`, '_blank')
//   }
// }

return { __sfc: true,showLogo, logoSrc, smallLogoSrc, route, router, routes, activeMenuName, username, logout, handleBackHome }
}

})